export default __webpack_public_path__ + "static/media/Manit04.48af6c8e.png";